import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "paypal",
  "name": "PayPal",
  "category": "integrations",
  "description": "Process payments with PayPal",
  "icon": "siPaypal",
  "iconType": "simple-icon",
  "color": "blue",
  "version": "1.1.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "PayPal",
    "color": "#003087"
  },
  "credentials": [
    {
      "name": "paypalApi",
      "required": true,
      "displayName": "PayPal API"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "paypal",
    "payment",
    "checkout",
    "transaction"
  ],
  "comingSoon": true
};

export default definition;
